import * as React from "react";

function IcPaymentCreditCardFill(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcPaymentCreditCardFill"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M23 9.5H1V6.5C1 5.11929 2.11929 4 3.5 4H20.5C21.8807 4 23 5.11929 23 6.5V9.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 11.5H23V17.5C23 18.8807 21.8807 20 20.5 20H3.5C2.11929 20 1 18.8807 1 17.5V11.5ZM11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15H11ZM17 17C16.4477 17 16 16.5523 16 16C16 15.4477 16.4477 15 17 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H17Z"
        fill={color}
      />
    </svg>
  );
}

export default IcPaymentCreditCardFill;
